<template>
  <transition name="fade">
      <div class="modal-mask" v-show="showModal"  @click.self="closeModal">
          <div class="message-box" :class="{ show: showModal }">
              <h2 class="message-title">日照分析说明</h2>
              <div class="message-content">
                <p class="bold">
                  国标有效日照时间：
                </p>
                <p>
                  冬至日：9：00-15：00<br>
                  其余节气：8：00-16：00
                </p>
                <p>
                  一般以
                  <span class="bold">冬至日</span>为日照时间参考标准。由于地理位置、经纬度等因素，部分地区以
                  <span class="bold">大寒日</span>为日照时间参考标准。
                </p>
                <p class="bold">
                  日照免责声明：
                </p>
                <p>
                  日照数据系依据政府规划公示图纸等第三方资料，经专业建模模拟评测得出。
                  请注意，该数据存在一定误差，仅供参考，不应单独作为交易决策的依据。
                  针对具体房源的日照信息及准确性，请务必与开发商核实，并以开发商提供的信息为准。
                  鉴于施工规划变更、图纸精度等因素，本日照模拟结果可能与实际情况存在偏差，数据仅供参考。
                </p>
                <p style="font-size: 14px;">
                  日照计算国标参考文件：<br>
                  ·《建筑日照计算参数标准》（GB/T 50947-2005）<br>
                  ·《城市居住区域规划设计规范》（GB/T 50180-93-2016）
                </p>
              </div>
              <button class="close-btn" @click="closeModal">了解了</button>
          </div>
      </div>
  </transition>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
      // this.showModal = false;
    }
  },
}
</script>

<style scoped>
  /* 蒙版样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 确保足够高的z-index */
    transition: opacity 0.3s;
  }
  /* 消息框样式 */
  .message-box {
    background: white;
    width: 80%;
    height: 50%;
    /* max-width: 450px; */
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
    transform: scale(0.7);
    transition: all 1s ease;
    color: #333;
  }
  
  .message-box.show {
    transform: scale(1);
  }

  .message-title {
    height: 10%;
    font-size: 1.8rem;
    margin: 10px;
    color: #2575fc;
    font-weight: 600;
  }
  
  .message-content {
    height: 70%;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 25px;
    color: #555;
    overflow-y: auto;
  }

  .message-content p {
    text-align: left;
  }

  .close-btn {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
  }

  .close-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(37, 117, 252, 0.4);
  }
  /* 动画效果 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .bold{
    font-weight: bold;
  }
</style>